import CertificateProvisionCheck from './CertificateProvisionCheck';
import React, { useEffect, useState } from 'react';
import { azureSqlService } from '@/services/azureSqlService.js';

export default function CertificateProvisionHistory({ onSelect }: { onSelect: (provision: string) => void }) {
  const [mode, setMode] = useState('history');
  const [query, setQuery] = useState('');
  const [options, setOptions] = useState<string[]>([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    let active = true;
    setOptions([]);
    setMessage('');
    if (mode !== 'history' || query.trim().length < 2) return;
    const timer = window.setTimeout(async () => {
      setMessage('Searching saved provisions…');
      try {
        const response = await azureSqlService.getCertificateProvisionHistory(query.trim());
        if (!active) return;
        const values = Array.isArray(response) ? response : response?.data;
        const matches = Array.isArray(values) ? values.filter((value): value is string => typeof value === 'string' && Boolean(value.trim())) : [];
        setOptions(matches);
        setMessage(matches.length ? 'Select a saved provision to add it below.' : 'No saved matches. Enter a new provision below and save the certificate to remember it.');
      } catch {
        if (active) setMessage('History could not be loaded. You can still enter provisions below.');
      }
    }, 300);
    return () => { active = false; window.clearTimeout(timer); };
  }, [query, mode]);

  return <div style={{ display: 'grid', gap: 8, marginBottom: 14 }}>
    <label>Provision source <select value={mode} onChange={e => setMode(e.target.value)}><option value="history">Saved provisions</option><option value="reference">Check provision - NCC reference</option></select></label>
    {mode === 'reference' ? <CertificateProvisionCheck onSelect={onSelect} /> : <>
    <label style={{ display: 'grid', gap: 6 }}>
      <span>Search saved provisions</span>
      <input type="search" value={query} maxLength={200} onChange={(event) => setQuery(event.target.value)} placeholder="Type at least 2 characters, e.g. NCC or H1P1" style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', border: '1px solid #dbe4f0', borderRadius: 10, font: 'inherit' }} />
    </label>
    {message && <div role="status" style={{ color: '#475569', fontSize: 13 }}>{message}</div>}
    {options.length > 0 && <ul aria-label="Saved provision matches" style={{ listStyle: 'none', padding: 0, margin: 0, display: 'grid', gap: 6, maxHeight: 240, overflowY: 'auto' }}>
      {options.map((option) => <li key={option}>
        <button type="button" onClick={() => { onSelect(option); setQuery(''); }} style={{ width: '100%', textAlign: 'left', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', border: '1px solid #dbe4f0', background: '#f7f9ff', borderRadius: 8, padding: '10px 12px', color: '#173b78', font: 'inherit', cursor: 'pointer' }}>{option}</button>
      </li>)}
    </ul>}
    </>}
    <div style={{ color: '#64748b', fontSize: 12 }}>Saving a new draft or amendments stores the provisions in database history for reuse. Review each selected provision for this inspection.</div>
  </div>;
}
